// Display text for task fields (constitution §5.10: plain English for helpers new to CIS).
import { formatLocal, programDayStart, type TaskStatus } from '@cis/shared';

export const STATUS_LABELS: Readonly<Record<TaskStatus, string>> = {
  not_started: 'Not started',
  in_progress: 'In progress',
  blocked: 'Blocked',
  done: 'Done',
  verified: 'Verified',
  deferred: 'Deferred',
  retired: 'Retired',
};

/** A calendar date ("2026-11-04") as people read it, in program time, never shifted a day. */
export function formatDate(date: string | null): string {
  return date === null ? '—' : formatLocal(programDayStart(date), 'date');
}
